import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, message);
    
    {/* replace below with your own Service ID, Template ID and Public Key from your EmailJS account */ }
    
    emailjs
      .sendForm("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", e.target, "YOUR_PUBLIC_KEY")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Ota meihin yhteyttä</h2>
                <p>
                
                </p>
              </div>
              <div className="Google-Maps">
                <iframe
                  title="Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1969.4774257046026!2d25.42635687761321!3d60.42082247516123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4691f845bc0c10b3%3A0x712a75c001ae2085!2sJOKOFIX%20OY%20%2F%20Autokorjaamo%20Koljonen!5e0!3m2!1sfi!2sfi!4v1768976540541!5m2!1sfi!2sfi"
                  width="90%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  refferrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                     
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                     
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                 
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                  
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Yhteystiedot</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Osoite
                </span>
                {props.data ? props.data.address : "Lataa"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Puhelin
                </span>{" "}
                  {props.data ? (
                    <a
                      className="phone-link"
                      href={`tel:${String(props.data.phone).replace(/[^\d+]/g, "")}`}
                    >
                      {props.data.phone}
                    </a>
                  ) : (
                      "Lataa"
                    )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Sähköposti
                </span>{" "}
                {props.data ? props.data.email : "Lataa"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 JokoFix
          </p>
        </div>
      </div>
    </div>
  );
};
